<script>
  import { External, M } from '../../external';
  import DateTimePicker from '../../Common/DateTimePicker.svelte';

  export let subscription;
  export const get = () => {
    return {
      selectedCyclesOption,
      selectedPeriodOption,
      selectedPeriodUnitOption,
      selectedPrice,
      selectedNextBillingDate
    };
  };

  const calcNextBillingDate = (timestamp) => {
    return new Date(timestamp - ((new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1);
  };

  let selectedCyclesOption = subscription.cycles;
  let selectedPeriodOption = subscription.period;
  let selectedPeriodUnitOption = subscription.periodUnit;
  let selectedPrice = subscription.price;
  let nextBillingDate = External.Tools.localDateTimeStringToDate(subscription.nextBillingDate);
  let selectedNextBillingDate = calcNextBillingDate(nextBillingDate ? nextBillingDate.getTime() : new Date().getTime());

</script>

<div class="popup-slider-wrapper">
  <div class="popup-input-wrapper">
    <div class="info">
      <h5>{M.BILLING_CYCLES}</h5>
    </div>
    <select bind:value={selectedCyclesOption} name="cycles">
      {#each {length: 53} as _, idx}
        <option value="{idx}">{idx === 0 ? '' : `${idx} `}{idx === 0 ? M.ONGOING_PAYMENTS : idx === 1 ? M.PAYMENT : M.PAYMENTS}</option>
      {/each}
    </select>
  </div>
  <div class="popup-input-wrapper">
    <div class="popup-input-wrapper">
      <h5>{M.CHARGE_EVERY}</h5>
    </div>
    <div class="input-wrapper2 f-left clear-left">
      <select bind:value={selectedPeriodOption} class="mt-0" name="period">
        {#each {length: 12} as _, idx}
          <option value="{idx + 1}">{idx + 1}</option>
        {/each}
      </select>
    </div>
    <div class="input-wrapper2 f-right">
      <select bind:value={selectedPeriodUnitOption} class="mt-0" name="periodUnit">
        <option value="WEEKLY">{M.WEEKS}</option>
        <option value="MONTHLY">{M.MONTHS}</option>
      </select>
    </div>
  </div>
  <div class="popup-input-wrapper">
    <div class="input-wrapper2 f-left clear-left">
      <h5>{M.PRICE}</h5>
      <div class="symbol-input price-input"
           class:left-sign={External.Website.storeCurrencyPositionAtLeft}
           class:right-sign={!External.Website.storeCurrencyPositionAtLeft}
      >
        <span class="symbol-sign">{External.Website.storeCurrencySymbol}</span>
        <input type="number" min="0.01" step="0.01" placeholder="0.00" bind:value={selectedPrice} />
      </div>
    </div>

    <div class="input-wrapper2 f-right flex flex-col">
      <h5>{M.NEXT_PAYMENT}</h5>
      <DateTimePicker onChange="{(time) => selectedNextBillingDate = calcNextBillingDate(time)}" value={nextBillingDate} />
    </div>

  </div>
</div>
